export default __webpack_public_path__ + "static/media/error.1730eca8.svg";